<template>
	<v-card class="loading-indicator-card">
        <v-card-text>
            {{ loadingText }}
            <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
        </v-card-text>
    </v-card>
</template>

<script>
	export default {
		props: {
			loadingText: {
				required: true,
				type: String
			}
		}
	};
</script>

<style scoped>
.loading-indicator-card {
    width: 300px;
}
</style>
